import { OrganizationalUnitsRepository } from "./adapters/repository";

import * as retrieveOrganizationalUnits from "./useCases/retrieveOrganizationalUnits";
import * as retrieveAllOrganizationalUnits from "./useCases/retrieveAllOrganizationalUnits";
import * as createOrganizationalUnit from "./useCases/createOrganizationalUnit";
import * as editOrganizationalUnit from "./useCases/editOrganizationalUnit";
import * as removeOrganizationalUnit from "./useCases/removeOrganizationalUnit";
import * as moveOrganizationalUnit from "./useCases/moveOrganizationalUnit";
import * as updateOrganizationalUnit from "./useCases/updateOrganizationalUnit";

enum UseCases {
  retrieveOrganizationalUnits = "retrieveOrganizationalUnits",
  retrieveAllOrganizationalUnits = "retrieveAllOrganizationalUnits",
  createOrganizationalUnit = "createOrganizationalUnit",
  editOrganizationalUnit = "editOrganizationalUnit",
  removeOrganizationalUnit = "removeOrganizationalUnit",
  moveOrganizationalUnit = "moveOrganizationalUnit",
  updateOrganizationalUnit = "updateOrganizationalUnit",
}

interface Core {
  [UseCases.retrieveOrganizationalUnits]: retrieveOrganizationalUnits.Interactor;
  [UseCases.retrieveAllOrganizationalUnits]: retrieveAllOrganizationalUnits.Interactor;
  [UseCases.createOrganizationalUnit]: createOrganizationalUnit.Interactor;
  [UseCases.editOrganizationalUnit]: editOrganizationalUnit.Interactor;
  [UseCases.removeOrganizationalUnit]: removeOrganizationalUnit.Interactor;
  [UseCases.moveOrganizationalUnit]: moveOrganizationalUnit.Interactor;
  [UseCases.updateOrganizationalUnit]: updateOrganizationalUnit.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: OrganizationalUnitsRepository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveOrganizationalUnits]:
      retrieveOrganizationalUnits.createInteractor(dependencies.repository),
    [UseCases.retrieveAllOrganizationalUnits]:
      retrieveAllOrganizationalUnits.createInteractor(dependencies.repository),
    [UseCases.createOrganizationalUnit]:
      createOrganizationalUnit.createInteractor(dependencies.repository),
    [UseCases.editOrganizationalUnit]: editOrganizationalUnit.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeOrganizationalUnit]:
      removeOrganizationalUnit.createInteractor(dependencies.repository),
    [UseCases.moveOrganizationalUnit]: moveOrganizationalUnit.createInteractor(
      dependencies.repository,
    ),
    [UseCases.updateOrganizationalUnit]:
      updateOrganizationalUnit.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
